import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;
// const apiServerUrl = "http://localhost:3002";

export const apiAttorneysSlice = createApi({
  reducerPath: "apiAttorneys",
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),

  tagTypes: ["AttorneysNotes"],

  endpoints: (builder) => ({
    getAttorneys: builder.query({
      query: (query: string) => ({
        url: `api/v1/attorneys/search${query}`,
        method: "POST",
        body: query
      })
    }),
    getAttorneysNotes: builder.query({
      providesTags: ["AttorneysNotes"],
      query: (id) => ({
        url: `/attorneys/${id}/attorney_notes`
      })
    }),
    createTargetNote: builder.mutation({
      invalidatesTags: ["AttorneysNotes"],
      query: ({ id, body }) => ({
        url: `/attorneys/${id}/attorney_notes`,
        method: "POST",
        body
      })
    }),
    deleteTargetNote: builder.mutation({
      invalidatesTags: ["AttorneysNotes"],
      query: ({ id, noteId }) => ({
        url: `/attorneys/${id}/attorney_notes/${noteId}`,
        method: "DELETE"
      })
    }),
    editTargetNote: builder.mutation({
      invalidatesTags: ["AttorneysNotes"],
      query: ({ id, body, noteId }) => ({
        url: `/attorneys/${id}/attorney_notes/${noteId}`,
        method: "PATCH",
        body
      })
    }),
    downloadAttorneys: builder.mutation({
      query: (query: string) => ({
        url: `api/v1/attorneys/download${query}`,
        method: "POST",
        body: query
      })
    })
  })
});

// Export hooks for usage in functional components
export const {
  useGetAttorneysQuery,
  useDownloadAttorneysMutation,
  useGetAttorneysNotesQuery,
  useEditTargetNoteMutation,
  useDeleteTargetNoteMutation,
  useCreateTargetNoteMutation
} = apiAttorneysSlice;
